import { useCallback, useEffect, useState } from "react";
import * as yup from "yup";
import { useSelector } from "../../../store/hooks";
import { isFormFieldVisible } from "../../../utils/valueFieldsVisibility";

const defaultSchemaObj = (isFieldVisible: (fieldName: string) => boolean) => {
  return {
    currencyCode: yup.mixed().required(),

    ...(isFieldVisible("buildingValues") && {
      buildingValues: yup.string().required(),
    }),
    ...(isFieldVisible("equipmentValues") && {
      equipmentValues: yup.string().required(),
    }),
    ...(isFieldVisible("stockValues") && {
      stockValues: yup.string().required(),
    }),
    ...(isFieldVisible("totalPd") && {
      totalPd: yup.string().required(),
    }),
    ...(isFieldVisible("totalPdBi") && {
      totalPdBi: yup.string().required(),
    }),
    ...(isFieldVisible("indemnityPeriodCode") && {
      indemnityPeriodCode: yup.mixed().required(),
    }),
    ...(isFieldVisible("businessInteruptionValuesBasedOnIndemnityPeriod") && {
      businessInteruptionValuesBasedOnIndemnityPeriod: yup.string().required(),
    }),
    ...(isFieldVisible("totalPdBiBasedOnIndemnityPeriod") && {
      totalPdBiBasedOnIndemnityPeriod: yup.string().required(),
    }),
    //clientComment: yup.string().required(),
    coveragePeriodFromDate: yup.date().required(),
    coveragePeriodToDate: yup.date().required(),
    desiredLocationOwningStatusCode: yup.mixed().required(),
    desiredLocationStatusCode: yup.mixed().required(),
    desiredLocationOwningStatusDate: yup.date().required(),
    desiredLocationStatusDate: yup.date().required(),
  };
};

function useValidationSchema() {
  const valueFieldsVisibility = useSelector(
    (s) => s.valueMonitoring.valueFieldsVisibility
  );

  const [validationSchemaObj, setValidationSchemaObject] = useState(
    defaultSchemaObj(() => true)
  );

  useEffect(() => {
    setValidationSchemaObject(
      defaultSchemaObj((fieldName) =>
        isFormFieldVisible(valueFieldsVisibility, fieldName)
      )
    );
  }, [valueFieldsVisibility]);

  const handleUpdateSchema = useCallback((addedSchemaObj) => {
    setValidationSchemaObject((prev) => {
      return {
        ...prev,
        ...addedSchemaObj,
      };
    });
  }, []);

  const validationSchema = yup.object().shape(validationSchemaObj);
  return {
    validationSchema,
    handleUpdateSchema,
  };
}

export default useValidationSchema;
